import { Component, Inject, OnInit } from '@angular/core';
import { ExecutionQTestCriticalInstrumentation } from '../../../../model/execution';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import * as _ from 'lodash';
import { InternalEquipment } from '../../../../model/internalEquipment';
import { EquipmentAutocompleteFilter } from '../../../../model/autocompleteFilter';
import { InternalEquipmentService } from '../../../../services/internalEquipment.service';
import { Subject, takeUntil } from 'rxjs';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { DateTime } from 'luxon';

import { ConfirmationDialogComponent } from '../../../shared/confirmation-dialog/confirmation-dialog.component';
import { SpinnerService } from '../../../../services/spinner.service';
import { v4 as uuid } from 'uuid';
import { EquipmentPerformances } from '../../../../utils/equipmentUtils';

export interface DialogDataCriticalEdit {
  criticalInstr: ExecutionQTestCriticalInstrumentation;
}

@Component({
    selector: 'app-execution-q-edit-test-critical-instrumentation',
    templateUrl: './execution-q-edit-test-critical-instrumentation.component.html',
    styleUrl: './execution-q-edit-test-critical-instrumentation.component.scss',
    standalone: false,
})
export class ExecutionQEditTestCriticalInstrumentationComponent implements OnInit {
  criticalInstrOriginal: ExecutionQTestCriticalInstrumentation;
  public equipmentAutoComplete: InternalEquipment[];

  private destroy$ = new Subject<void>();

  constructor(
    private internalEquipmentService: InternalEquipmentService,
    private dialogRef: MatDialogRef<ExecutionQEditTestCriticalInstrumentationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataCriticalEdit,
    private translate: TranslateService,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService,
    public dialog: MatDialog) {
  }
  ngOnInit(): void {
    this.criticalInstrOriginal = _.cloneDeep(this.data.criticalInstr);
  }

  onOkClick(): void {
    const errs = [];

    if (!this.requiredReason()) {
      this.data.criticalInstr.reasonChange = null;
    } else if (this.data.criticalInstr.reasonChange == null || this.data.criticalInstr.reasonChange === '') {
      errs.push(this.translate.instant('common.reasonChangeError'));
    }

    if (errs.length === 0) {
      this.spinnerService.show();
      if (!this.data.criticalInstr.id) {
        this.data.criticalInstr.uuid = uuid();
      }

      if (this.data.criticalInstr?.internalId) {
        this.internalEquipmentService.findOneByName(this.data.criticalInstr.internalId).pipe(takeUntil(this.destroy$)).subscribe((item: InternalEquipment) => {
          if (item) {
            this.data.criticalInstr.idEquipment = item.id;
            this.data.criticalInstr.maker = item.maker;
            this.data.criticalInstr.model = item.model;
            this.data.criticalInstr.certificateNum = item.certificateNum;
            this.data.criticalInstr.serialNum = item.serialNum;
            this.data.criticalInstr.idCertificate = item.idCertificate;
            this.data.criticalInstr.internalId = item.name;
            this.data.criticalInstr.equipment = item.equipment;
          } else {
            this.data.criticalInstr.idEquipment = null;
          }
          this.spinnerService.hide();
          this.dialogRef.close(this.data.criticalInstr);
        }, (error) => {
          console.log(error);
          this.spinnerService.hide();
        });
      } else {
        this.spinnerService.hide();
        this.dialogRef.close(this.data.criticalInstr);
      }
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
    }
  }
  requiredReason(): boolean {
    let res = false;

    return res;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  displayFn(eq?: InternalEquipment | string | { name: string }): string {
    if (!eq) {
      return null;
    }

    let res: string = null;

    if (typeof eq === 'string') {
      res = eq;
    } else if (eq instanceof InternalEquipment || eq.name != null) {
      res = eq.name;
    }

    return res;
  }

  lookupEquipment($event): void {
    let results = this.equipmentAutoComplete;

    const filter = new EquipmentAutocompleteFilter();

    filter.query = $event.target.value as string;
    filter.pageIndex = 0;
    filter.pageSize = 10;
    filter.sortBy = 'name';
    filter.sortDirection = 'asc';
		filter.forExecution = true;

    this.internalEquipmentService.findAutocomplete(filter).pipe(takeUntil(this.destroy$)).subscribe(item => {
      results = item.content;
      this.equipmentAutoComplete = results;
    }, () => {
      this.equipmentAutoComplete = results;
    });
  }

    onEquipmpentChange($event: any, trigger: MatAutocompleteTrigger): void {
      const equipmentSelected = $event.option.value as InternalEquipment;
      const eqCalibration = equipmentSelected.performances?.find(ep => ep.idActionType === EquipmentPerformances.CALIBRATION);
      
      if (eqCalibration.nearToExpire || eqCalibration.expired) {
  
        this.data.criticalInstr.idEquipment = equipmentSelected.id;
  
        const expirationDate = DateTime.fromJSDate(eqCalibration.expirationDate).toFormat('dd/MMM/yyyy').replace('./', '/').toUpperCase();
  
        let message = this.translate.instant('executionEdit.essays.sensor.form.error.nearToExpire', { expirationDate }) as string;
  
        if (eqCalibration.expired) {
          message = this.translate.instant('executionEdit.essays.sensor.form.error.expired') as string;
        }
  
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });
  
        dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
          if (result === true) {
            this.data.criticalInstr.idEquipment = equipmentSelected.id;
            this.data.criticalInstr.internalId = equipmentSelected.name;
          } else {
            this.data.criticalInstr.idEquipment = null;
            this.data.criticalInstr.internalId = null;
          }
        });
      } else {
        this.data.criticalInstr.idEquipment = equipmentSelected.id;
        this.data.criticalInstr.internalId = equipmentSelected.name;
      }
      event.stopPropagation();
      trigger.closePanel();
    }
}
